import { ShuteState, WebSocketCallback, WebSocketMessage } from "./shuteSlice";

export const callbackFunctions:Record<string, WebSocketCallback>={}

export const triggerCallbacks = (eventName: string, message: WebSocketMessage,state: { shute: ShuteState }) => {
    const splitEventName = eventName.split('.');
    const eventDepth = splitEventName.length;
    const registry = state.shute.callbackRegistry; // Accessing registry from the state


    // Check each registered event
    // console.log(registry)
    for (let registeredEvent in registry) {
        // console.log(`checking ${registeredEvent}`)
        const registeredDepth = registry[registeredEvent].depth;
        if (registeredDepth <= eventDepth) {
            // Check if the initial segments match
            const registeredSegments = registeredEvent.split('.');
            // console.log(registeredSegments,splitEventName)

            let isMatch = true;
            for (let i = 0; i < registeredDepth; i++) {
                if (registeredSegments[i] !== splitEventName[i]) {
                    isMatch = false;
                    break;
                }
            }
            // console.log(`is a match: ${isMatch}`)
            if (isMatch) {
                registry[registeredEvent].callbackKeys.forEach((key:string) => {
                    const callback = callbackFunctions[key];
                    if (callback) {
                        try {
                            callback(message);
                        } catch (cbErr) {
                            console.error(`[SHUTE-CB] ${key} threw:`, cbErr);
                        }
                    }
                });
            }
        // } else {
        //     console.log(`is a match: Hard pass`,registeredDepth,eventDepth)
        }
    }
};
